
const a = require("handlebars");


export const handlebar:any = a;